import { Helmet } from 'react-helmet-async';
import AdminLayout from '@/components/layout/AdminLayout';
import { useState, useEffect } from 'react';
import apiService from '@/services/api';

const AdminProviderCompliancePage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [fetchedData, setFetchedData] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService.request('/admin/providers/compliance', 'GET');
        if (response.success && response.data) {
          setFetchedData(response.data);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  // Handler: Check compliance status
  const handleCheckComplianceStatus = async (providerId?: string) => {
    setIsLoading(true);
    try {
      const response = await apiService.request('/admin/compliance/check-status', 'POST', {
        providerId: providerId,
        checkedBy: localStorage.getItem('adminId'),
        checkedAt: new Date().toISOString()
      });
      if (response.success) {
        alert(`✓ Status: ${response.data?.status || 'Compliant'}`);
      } else alert('Error: ' + response.message);
    } catch (error: any) {
      alert('Failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler: Update compliance flag
  const handleUpdateComplianceFlag = async (providerId: string, flagType: string) => {
    setIsLoading(true);
    try {
      const response = await apiService.request(`/admin/compliance/${providerId}/flag`, 'POST', {
        flagType: flagType,
        flaggedBy: localStorage.getItem('adminId'),
        flaggedAt: new Date().toISOString()
      });
      if (response.success) {
        alert('✓ Compliance flag updated');
        window.location.reload();
      } else alert('Error: ' + response.message);
    } catch (error: any) {
      alert('Failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler: Generate compliance report
  const handleGenerateComplianceReport = async () => {
    setIsLoading(true);
    try {
      const response = await apiService.request('/admin/compliance/report', 'GET');
      if (response.success && response.data) {
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `compliance-${new Date().toISOString().split('T')[0]}.csv`;
        a.click();
        window.URL.revokeObjectURL(url);
        alert('✓ Report generated');
      } else alert('Error: ' + response.message);
    } catch (error: any) {
      alert('Failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler: Run compliance audit
  const handleRunComplianceAudit = async () => {
    setIsLoading(true);
    try {
      const response = await apiService.request('/admin/compliance/audit', 'POST', {
        auditedBy: localStorage.getItem('adminId'),
        auditedAt: new Date().toISOString()
      });
      if (response.success) {
        alert(`✓ Audit complete: ${response.data?.issues || 0} issues found`);
        window.location.reload();
      } else alert('Error: ' + response.message);
    } catch (error: any) {
      alert('Failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Handler: Bulk compliance update
  const handleBulkComplianceUpdate = async () => {
    setIsLoading(true);
    try {
      const response = await apiService.request('/admin/compliance/bulk-update', 'POST', {
        updatedBy: localStorage.getItem('adminId'),
        updatedAt: new Date().toISOString()
      });
      if (response.success) {
        alert('✓ Bulk update complete');
        window.location.reload();
      } else alert('Error: ' + response.message);
    } catch (error: any) {
      alert('Failed: ' + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Provider Compliance - Virewire Admin</title>
      </Helmet>
      <AdminLayout>
        <div className="bg-gray-50 min-h-screen p-8">
          <div className="bg-white rounded-xl border border-gray-200 p-8 shadow-sm">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Provider Compliance</h1>
            <p className="text-gray-600">Compliance status and verification management for providers.</p>
          </div>
        </div>
      </AdminLayout>
    </>
  );
};

export default AdminProviderCompliancePage;
